<div class="request-customfield-order-container">
	<div class="header-wrap">
		<span class="tab selected">
			<fa-icon [icon]="icons.faFloppyDisk"></fa-icon>
			{{ labels.lbl_ordenar_campos_customizados }}
		</span>
	</div>

	<div class="body-wrap">
		<div class="form-wrap">
			<div class="section-heading">
				<span class="title">{{ labels.lbl_geral_campos_customizados }}</span>
				<span class="description">{{ labels.lbl_selecione_classificacao }}</span>
			</div>

			<pcp-request-classification-reverse-rmk
				[alertField]="classificationOptions.alertField"
				[idCustomerList]="classificationOptions.selectedCustomer"
				[hideField]="classificationOptions.hideField"
				(getClassification)="setClassification($event)">
			</pcp-request-classification-reverse-rmk>

			<div class="button-container">
				<div class="button" [ngClass]="{ disabled: isLoading }" (click)="loadFields()">
					{{ labels.lbl_geral_buscar }}
					<cpi-dot-bounce-loading-effect *ngIf="isLoading" [color]="'var(--const-white)'"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>

		<div class="form-wrap order-wrap" *ngIf="hasSearched">
			<div class="section-heading">
				<span class="title">{{ labels.lbl_ordenar_campos_customizados }}</span>
				<span class="description">{{ labels.lbl_arraste_ou_use_controles }}</span>
			</div>

			<div class="empty-state" *ngIf="!isLoading && fields.length === 0">{{ labels.lbl_nenhum_campo }}</div>

			<div class="field-list" *ngIf="fields.length > 0">
				<div class="field-row" *ngFor="let field of fields; let i = index">
					<input
						class="position-input"
						type="number"
						min="1"
						[max]="fields.length"
						[value]="field.position"
						(input)="field.position = $any($event.target).value"
						(change)="setFieldPosition(i, field, $event)"
						title="Posição do campo" />
					<div class="field-info">
						<strong>{{ field.field_name }}</strong>
						<span>{{ field.field_type }}<span *ngIf="field.required"> · obrigatório</span></span>
					</div>
					<div class="move-actions">
						<button type="button" class="icon-button" [disabled]="i === 0" (click)="moveField(i, -1)" title="Mover para cima">
							<fa-icon [icon]="icons.faAngleUp"></fa-icon>
						</button>
						<button
							type="button"
							class="icon-button"
							[disabled]="i === fields.length - 1"
							(click)="moveField(i, 1)"
							title="Mover para baixo">
							<fa-icon [icon]="icons.faAngleDown"></fa-icon>
						</button>
					</div>
				</div>
			</div>

			<div class="button-container" *ngIf="fields.length > 0">
				<div class="button" [ngClass]="{ disabled: isSaving }" (click)="save()">
					<fa-icon [icon]="icons.faFloppyDisk"></fa-icon>
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect *ngIf="isSaving" [color]="'var(--const-white)'"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>
	</div>
</div>
